module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// ./~/zen-observable/index.js
// module id = 1884
// module chunks = 0